import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { compose } from 'redux';
import { FormattedMessage } from 'react-intl';
import { Table } from 'react-bootstrap';
import withSettings from 'containers/SettingsProvider/withSettings';
import withDialog from 'containers/Dialog/withDialog';
import withKvApi from 'containers/KmVretersPage/withKvApi';
import Pagination from 'components/Pagination';
import { PAGESIZE } from 'utils/constants';
import formatTime from 'utils/formatTime';
import distanceString from '../distanceString';
import listByPeriod from './listByPeriod';
import messages from '../messages';
import getGraphData from './getGraphData';
import CombiChart from './CombiChart';

const Wrapper = styled.div`
  padding-top: 20px;
  table.table {
    @media (max-width: 479px) {
      font-size: smaller;
    }
    && thead > tr > th {
      vertical-align: top;
      .units {
        font-weight: normal;
      }
    }
    th,
    td {
      text-align: right;
    }
    .td-link {
      text-align: center;
    }
  }
`;

const Units = styled.div`
  font-weight: normal;
`;

function Period(props) {
  const { data, units, period } = props;
  const [offset, setOffset] = useState(0);

  const handlePaging = useCallback(newOffset => setOffset(newOffset), []);

  const { list } = data.value;
  const tableList = listByPeriod(list, period);
  const slicedList = tableList.slice(offset, offset + PAGESIZE);
  const graphData = getGraphData(tableList, period, units);

  return (
    <Wrapper>
      <CombiChart data={graphData} period={period} />
      <Table responsive hover>
        <thead>
          <tr>
            <th>
              <FormattedMessage {...messages[period]} />
            </th>
            <th>
              <FormattedMessage {...messages.number} />
            </th>
            <th>
              <FormattedMessage {...messages.distance} />
              <Units>({units})</Units>
            </th>
            <th>
              <FormattedMessage {...messages.avgDistance} />
              <Units>({units})</Units>
            </th>
            <th>
              <FormattedMessage {...messages.pace} />
              <Units>(min/{units})</Units>
            </th>
            <th>
              <FormattedMessage {...messages.speed} />
              <Units>
                ({units}/<FormattedMessage {...messages.hr} />)
              </Units>
            </th>
          </tr>
        </thead>
        <tbody>
          {slicedList.map(item => (
            <tr key={item.dateStr}>
              <td className="td-date">{item.dateStr}</td>
              <td className="td-number">{item.number}</td>
              <td className="td-distance">
                {distanceString(item.distance, units)}
              </td>
              <td className="td-distance">
                {distanceString(item.distance / item.number, units)}
              </td>
              <td className="td-time">
                {formatTime(item.time / item.distance)}
              </td>
              <td className="td-distance">
                {distanceString((item.distance * 3600) / item.time, units, 2)}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination
        value={offset}
        length={tableList.length}
        onChange={handlePaging}
      />
    </Wrapper>
  );
}

Period.propTypes = {
  data: PropTypes.object.isRequired,
  units: PropTypes.string.isRequired,
  period: PropTypes.string.isRequired,
  dlgConfirm: PropTypes.func.isRequired,
  apiChange: PropTypes.func.isRequired,
};

export default compose(
  withDialog,
  withKvApi,
  withSettings(['units']),
)(Period);
